import s from './ListCard.module.scss';
import {TListCardProps} from "@/app/[locale]/common/components/ListCard/types";

export const ListCard = ({ width, data, pointIcon }: TListCardProps) => {
    return (
        <div className={`${s.listCard} ${width ? s[`listCard_${width}`] : ''}`}>
            <label>{ data.LABEL }</label>

            <div className={s.listCard_list}>
                {
                    data.POINTS.map((item: string, index: number) => (
                        <ul key={index}>
                            <li className={s.listCard_item}>
                                { pointIcon }
                                {item}
                            </li>
                        </ul>
                    ))
                }
            </div>
        </div>
    );
};